'use strict';

import { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Modal from 'react-modal';

import CalendarWidget from '@components/Widgets/CalendarWidget.react';

import './PickDateModal.scss';

const PickDateModal = ({ dateStart, onPickDate, closeModal, formatDate }) => {
    const [date, setDate] = useState(dateStart ? moment(dateStart) : moment());

    // Use provided formatDate or default to moment formatting
    const formatDateDisplay = useCallback((dateToFormat) => {
        if (formatDate) {
            return formatDate(dateToFormat, 'dddd MMMM Do');
        }
        return moment(dateToFormat).format('dddd MMMM Do');
    }, [formatDate]);

    const onChangeDate = useCallback((newDate) => {
        setDate(moment(newDate));
    }, []);

    const handlePickDate = useCallback(() => {
        onPickDate(date);
    }, [onPickDate, date]);

    return (
        <Modal isOpen={true}
            onRequestClose={closeModal}
            closeModal={closeModal}
            className="el-modal el-modal3 el-modal3-fixed"
            overlayClassName="el-modal-overlay"
            contentLabel="Pick Date"
            closeTimeoutMS={250}>

            <section className="el-modal-container el-modal3-container pick-date-modal-container">
                <header>
                    <h2>Please choose a date to start this meal plan on.</h2>
                    
                    <button onClick={closeModal} className="el-modal-close-x">
                        <i className="icon-close-x" />
                        <span className="assistive-text">Close Modal</span>
                    </button>
                </header>

                <div className="el-modal-body-container el-modal3-body-container">
                    <CalendarWidget minDate={new Date()}
                        value={date.toDate()}
                        onChange={onChangeDate} />
                    
                    <p className="date-selection-text">Meal Plan will be scheduled for <strong>{formatDateDisplay(date)}</strong></p>
                </div>

                <footer>
                    <button className="el-modal-cancel-btn" onClick={closeModal}>Cancel</button>
                    <button className="el-modal-ok-btn" onClick={handlePickDate}>Schedule</button>
                </footer>
            </section>
        </Modal>
    );
};

PickDateModal.propTypes = {
    dateStart: PropTypes.object,
    onPickDate: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
    formatDate: PropTypes.func,
};

export default PickDateModal;